import React from "react";
import "./Styles.css";
import { useNavigate } from "react-router-dom";

export default function VisionSection() {
  const navigate = useNavigate();

  return (
    <div className="vision-container" id="vision">
      <div className="vision-card">

        {/* LEFT */}
        <div className="vision-left">
          <p className="vision-tag">OUR VISION</p>

          <h2>
            Human potential, <br />
            amplified <span>by AI.</span>
          </h2>
        </div>

        {/* RIGHT */}
        <div className="vision-right">
          <p>
            We envision a world where AI is personal, empowering,
            and accessible to all. Our mission is to build technology
            that augments human creativity, productivity, and well-being.
          </p>

          <button
                className="vision-btn"
                onClick={() => navigate("/about-us")}
              >
                Learn More About Us →
              </button>
        </div>

      </div>
    </div>
  );
}